export default __webpack_public_path__ + "static/media/image.fund-me-srilanka.ebe75317.png";